import { render, staticRenderFns } from "./BrokerReports.vue?vue&type=template&id=107c5ce9&"
import script from "./BrokerReports.vue?vue&type=script&lang=js&"
export * from "./BrokerReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports